import { FC } from 'react'
import styles from 'components/atoms/accordion/AccordionTab/AccordionTab.styl'
import cn from 'classnames'
import { useInputTheme } from 'components/features/theme/useInputTheme'


type AccordionTabProps = {
  label: string
  isOpen: boolean
  onClick: () => void
}

export const AccordionTab: FC<AccordionTabProps> = (props) => {
  const { label, children, isOpen, onClick } = props

  const { futureFieldTitle } = useInputTheme()

  return (
    <section className={ cn(styles.tab, styles[futureFieldTitle], isOpen && styles.open) }>
      <label className={ styles.tabLabel } onClick={ onClick }>{ label }</label>
      <div className={ styles.tabContent }>
        { children }
      </div>
    </section>
  )
}
